import { CircularProgress, styled, Typography } from '@mui/material';
import { FC } from 'react';
import CenteredContainer from 'src/components/atoms/CenteredContainer';

export const DataTableLoading: FC = () => {
    return (
        <StyledContainer sx={{ gap: 4 }}>
            <Loader size="16px" />
            <Typography variant="caption">Loading...</Typography>
        </StyledContainer>
    );
};

const StyledContainer = styled(CenteredContainer)(({ theme }) => ({
    border: `1px solid ${theme.palette.grey[300]}`,
}));

const Loader = styled(CircularProgress)(({ theme }) => ({
    color: theme.palette.grey[800],
}));
